export const SECONDARY = {
  DARKEST: '#0A1814',
  DARKER: '#123328',
  DARK: '#226D54',
  DEFAULT: '#226D54',
  LIGHT: '#B1D9CD',
  LIGHTER: '#E0F1EB',
  LIGHTEST: '#F1FAF7',
} as const;
